"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _actions = require("../actions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const mapStateToProps = state => {
  return {
    auth: state.auth
  };
};
const mapDispatchToProps = dispatch => {
  return (0, _redux.bindActionCreators)({
    signIn: _actions.signIn,
    authenticate: _actions.authenticate,
    createSession: _actions.createSession,
    dispatch
  }, dispatch);
};
class SignIn extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      email: "",
      password: ""
    });
    _defineProperty(this, "componentDidUpdate", () => {
      if (this.props.auth.state === "LOGGED_IN") {
        this.props.history.push(this.props.auth.onSignInRedirect);
      }
    });
    _defineProperty(this, "handleChange", ({
      target
    }) => {
      const {
        value,
        name
      } = target;
      this.setState({
        [name]: value
      });
    });
    _defineProperty(this, "handleSubmit", () => {
      const {
        email,
        password
      } = this.state;
      const {
        auth,
        history,
        dispatch,
        location
      } = this.props;
      this.props.signIn(email.toLowerCase(), password).then(response => {
        if (response.signInUserSession.idToken.jwtToken) {
          this.props.createSession(response.signInUserSession.idToken.jwtToken);
        }
        if (!response.challengeName) this.props.authenticate().then(response => {
          if (!history) {
            console.error("No prop history in container SignIn. Probably you have forgotten to pass props through.");
          }
          if (!location || !location.state && history) {
            history.push(auth.onSignInRedirect);
          }
          if (auth.onAuthenticateSuccess) {
            auth.onAuthenticateSuccess({
              history,
              dispatch,
              location
            }, response);
          }
        });
      }).catch(err => console.dir(err));
    });
    _defineProperty(this, "render", () => {
      const {
        auth,
        children
      } = this.props;
      const {
        email,
        password
      } = this.props;
      return _react.default.cloneElement(children, {
        state: {
          email,
          password
        },
        auth,
        onChange: this.handleChange,
        onSubmit: this.handleSubmit,
        error: auth.error,
        message: auth.message
      });
    });
  }
}
var _default = exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SignIn));
module.exports = exports.default;